const ordersKeys = {
  module: ['orders'] as const,
  list: () => [...ordersKeys.module, 'list'] as const,
  all: () => [...ordersKeys.module, 'all'] as const,
  listWithFilters: (filters: any) => [...ordersKeys.list(), filters] as const,
  details: (id: string) => [...ordersKeys.module, 'details', id] as const,
  occurrences: (id: string) =>
    [...ordersKeys.module, 'occurrences', id] as const,
  cities: (cityId: string) => [...ordersKeys.module, 'cities', cityId] as const,
  deliveryPrice: (companyId: string) => [
    ...ordersKeys.module,
    'deliveryPrice',
    companyId,
  ],
};

export default ordersKeys;
